const popupInit = () => {
  const popup: HTMLElement = document.querySelector('.footer .popup');
  const close: HTMLElement = document.querySelector(
    '.footer .popup .popup__close',
  );

  let functionCalls = 0;

  function openPopup(): any {
    functionCalls += 1;

    if (functionCalls === 1) {
      popup.classList.add('popup--show');
    }
  }

  function closePopup() {
    popup.classList.remove('popup--show');
  }

  close.addEventListener('click', () => {
    closePopup();
  });

  document.addEventListener('mouseleave', (event) => {
    if (
      event.clientY <= 0
      || event.clientX <= 0
      || event.clientX >= window.innerWidth
      || event.clientY >= window.innerHeight
    ) {
      openPopup();
    }
  });
  if (window.innerWidth < 992) {
    setTimeout(openPopup, 30000);
  }
};

export default popupInit;
